import { REMOVE_SELECTED_CONTACT } from 'actions';

export default function removeSelectedContact() {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SELECTED_CONTACT,
    });
  };
}
